import React from 'react'
import { Table } from 'react-bootstrap'
import {
	videoPlayCountersteluguContentVideoHeadings,
	videoPlayCountersenglishContentVideoHeadings,
} from '../Data/StaticData'
class ListVideosByLanguage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

					teluguContentVideoHeadings: videoPlayCountersteluguContentVideoHeadings,
					englishContentVideoHeadings: videoPlayCountersenglishContentVideoHeadings,
        }
    }


	renderTeluguContentVideoTable = (teluguContentVideoHeadings, videoPlayCounters) => {
		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{teluguContentVideoHeadings.map((head) => (
							<th class='tableRowStyle'>{head}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{videoPlayCounters &&
						videoPlayCounters.map((row) => this.renderTeluguContentVideoTableRow(row))}
				</tbody>
			</Table>
		)
	}
	renderTeluguContentVideoTableRow = (item) => {
		let day = item.Day ? item.Day.charAt(0).toUpperCase() + item.Day.slice(1) : null
		let date = item.SK
			? item.SK.split('/')[2] + '/' + item.SK.split('/')[1] + '/' + item.SK.split('/')[0]
			: null
		return (
			<tr>
				<td class='tdCellStyle'>{date}</td>
				<td class='tdCellStyle'>{item.Telugu_Content_Videos_likes}</td>
				<td class='tdCellStyle'>{item.Telugu_Content_Videos_shares}</td>
				<td class='tdCellStyle'>{item.Telugu_Content_Videos_views}</td>
				<td class='tdCellStyle'>{item.Guest_Telugu_Content_Videos_likes}</td>
				<td class='tdCellStyle'>{item.Guest_Telugu_Content_Videos_shares}</td>
				<td class='tdCellStyle'>{item.Guest_Telugu_Content_Videos_views}</td>

				<td class='tdCellStyle'>{day}</td>

            </tr>
        )
    }


	renderEnglishContentVideoTable = (englishContentVideoHeadings, videoPlayCounters) => {
		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{englishContentVideoHeadings.map((head) => (
							<th class='tableRowStyle'>{head}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{videoPlayCounters &&
						videoPlayCounters.map((row) => this.renderEnglishContentVideoTableRow(row))}
				</tbody>
			</Table>
		)
	}
	renderEnglishContentVideoTableRow = (item) => {
		let day = item.Day ? item.Day.charAt(0).toUpperCase() + item.Day.slice(1) : null
		let date = item.SK
			? item.SK.split('/')[2] + '/' + item.SK.split('/')[1] + '/' + item.SK.split('/')[0]
			: null
		return (
			<tr>
				<td class='tdCellStyle'>{date}</td>
				<td class='tdCellStyle'>{item.English_Content_Videos_likes}</td>
				<td class='tdCellStyle'>{item.English_Content_Videos_shares}</td>
				<td class='tdCellStyle'>{item.English_Content_Videos_views}</td>
				<td class='tdCellStyle'>{item.Guest_English_Content_Videos_likes}</td>
				<td class='tdCellStyle'>{item.Guest_English_Content_Videos_shares}</td>
				<td class='tdCellStyle'>{item.Guest_English_Content_Videos_views}</td>
				<td class='tdCellStyle'>{day}</td>

            </tr>
        )
    }
    render() {
			const {
            appLang,
				availableData,
        } = this.props

        const {
					teluguContentVideoHeadings,
					englishContentVideoHeadings,
        } = this.state
        return (
            <div>
                {appLang === 'Telugu' ? (
                    availableData === true ? (
                        <div style={{ marginTop: 10 }}>
									{this.renderTeluguContentVideoTable(teluguContentVideoHeadings, this.props.ListVideoPlayCounters)}
								</div>
							) : (
								<div>No Data To Display</div>
							)
						) :
							appLang === 'English' ? (
								availableData === true ? (
									<div style={{ marginTop: 10 }}>
										{this.renderEnglishContentVideoTable(englishContentVideoHeadings, this.props.ListVideoPlayCounters)}
									</div>
								) : (
									<div>No Data To Display</div>
								)
							) : null}

            </div>

        )

    }


}
export default ListVideosByLanguage
